import createUploadLink from 'apollo-upload-client/createUploadLink.mjs'

import { jobsGraphqlUrl } from '@/config/env'

import { uploadFetch } from './uploadFetch'

export const jobsHttpLink = createUploadLink({
  credentials: 'include',
  uri: jobsGraphqlUrl,
  fetch: uploadFetch,
})
